import React from 'react';
import agentPageStore from '../store';
import { SVGPureIcon } from '@/ui';
import navbarStore from '@/store/navbar';
import { observer } from 'mobx-react-lite';
import globalStore from '@/store/global';

const BackBtn = observer(() => {
  return (
    <div
      onClick={evt => {
        globalStore.navigate('/tools/aiagent')
      }}
      className={[
        'flex items-center cursor-pointer',
        navbarStore.isCollapse ? 'ml-56px' : 'ml-0px',
      ]}
    >
      <div className='size-32px rounded-8px hover:bg-black hover:bg-opacity-3 flex items-center justify-center mr-12px'>
        <SVGPureIcon name="header_back_arrow" className="size-24px" />
      </div>
      <div className="leading-28px text-20px font-bold">我的智能体</div>
    </div>
  );
});

export default BackBtn;
